import React, { useState, useContext, useEffect } from 'react';
import { Header, Container, Grid, Modal } from 'semantic-ui-react';
import { Button, Form, Icon, Dropdown, Divider } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { AppState } from '../context';
import 'firebase/database';
import { dbFamMember, dbCaregivers, dbTasks } from '../firebase';
import 'firebase/functions';

const EditTask = () => {
    const someContext = useContext(AppState);
    let { taskid } = useParams();
    console.log(taskid)
    const {
  
      messageBody,
      setMessageBody,
      familyMembers,
      setFamilyMembers,
      tasks,
      setTasks,
      caregivers,
      setCaregivers
    } = someContext;
  const [ taskk, setTask] = useState("")
  const [time, setTime] = useState("")
  const [taskDescription, setTaskdescription] = useState("")
  const [importance, setImportance] = useState("")
  const [frequency, setFrequency] = useState("")
  const [familyMemberID, setFamilyMemberID]=useState("")

  const [caregiverID,setCaregiverID]=useState(0);
  const[status, setStatus]=useState(false);
  const [items, setItems] = useState([])
  const [opened, setOpened] = useState(true);
  const [message, setMessage] = useState({ to: '', body: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [finalmsg, setFinalmsg] = useState({ to: '+12243073351', body: 'o' });
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [caregiverFirst, setCaregiverFirst]=useState("nairobi")
  function updateCaregiverID() {
    if (opened) {
      if (familyMembers && caregivers) {
        familyMembers[familyMemberID]["caregivers"].map((input) => {
          setItems(items => [...items, {
            key: caregivers[input]["id"],
            text: caregivers[input]["firstName"] + " " + caregivers[input]["lastName"],
            value: caregivers[input]["id"]
          }])
        })
        
        console.log(familyMembers[familyMemberID]["caregivers"])
      }
      setOpened(false);

    }
    console.log(items)
  }

  useEffect(() => {
    const handleData = snapshot => {
      if (snapshot.val()) 
      setCaregiverID(snapshot.val()[taskid]['caregiverId']);
      setTask(snapshot.val()[taskid]['taskName']);
      setTaskdescription(snapshot.val()[taskid]['description']);
      setFrequency(snapshot.val()[taskid]['frequency']);
      setImportance(snapshot.val()[taskid]['importance']);
      setTime(snapshot.val()[taskid]['time']);
      setStatus(snapshot.val()[taskid]['status']);
      setFamilyMemberID(snapshot.val()[taskid]['familyMemberID'])
      var tempmaster=[];
      var temp=[]
      // console.log(familyMembers)
      // if (familyMembers) {
      //   console.log('reached here')
      //   temp=familyMembers[snapshot.val()[taskid]["familyMemberID"]]["caregivers"]
      // }
      function handleTemp (snappy) {
        temp=snappy.val()
        console.log("this is the mawroba temp")
        console.log(temp)
      }
      dbFamMember.child(snapshot.val()[taskid]['familyMemberID']).child("caregivers").once('value', handleTemp, error => alert(error));
      
      console.log(temp);
      for(var i=0; i< temp.length; i++){
        var firstname=""
      //   if(caregivers){
      //     firstname=caregivers[temp[i]]["firstName"]
      //   }
        function handleCaregivers(snappy2){
          firstname=snappy2.val().firstName;
          console.log(firstname);
        }
        dbCaregivers.child(temp[i]).once('value', handleCaregivers, error => alert(error))
        if(temp[i]==caregiverID){
          setCaregiverFirst(firstname);
          console.log("NARIOBI NAIROBI NAIROBI")
          console.log(caregiverFirst)
          console.log(temp[i])
        }
        
        tempmaster.push({
          key: i,
          text: firstname,
          value: firstname
        })
      }
      // setItems(tempmaster);
      console.log(tempmaster)
    }
    dbTasks.on('value', handleData, error => alert(error));
    return () => { dbTasks.off('value', handleData); };
  }, [taskid]);
  
  useEffect(()=>{
    const  initialzeName = (snappy3) =>{
      setCaregiverFirst(snappy3.val().firstName)
      console.log("crucial check")
      console.log(snappy3.val())
    }
    dbCaregivers.on('value',initialzeName,error=>alert(error));
    return ()=>{dbCaregivers.child(caregiverID).off('value',initialzeName)}
  }, [caregiverID, familyMembers]);

    const Importance_Array = [
      {
        key: 0,
        text: "Low",
        value: "Low"
      },
      {
        key: 1,
        text: "Medium",
        value: "Medium"
      },
      {
        key: 2,
        text: "High",
        value: "High"
      },
    ]
    const Frequency_Array = [
      {
        key: 0,
        text: "Twice a Day",
        value: "Twice a Day"
      },
      {
        key: 1,
        text: "Everyday",
        value: "Everyday"
      },
      {
        key: 2,
        text: "Weekly",
        value: "Weeklly"
      },
      {
        key: 3,
        text: "Other",
        value: "Other"
      },
    ]
  
    function updateTask(){
      dbTasks.child(taskid).update({
        caregiverId: caregiverID,
        taskName: taskk,
        description: taskDescription,
        frequency: frequency,
        importance: importance,
        time: time,
        status: status,
      })
    }
    // console.log(Importance_Array[Importance_Array.findIndex((i)=>i.text==importance)])
    return (
        <Container>
           <Divider hidden />
          <Modal open={isModalOpen} basic size='small' onClose={() => setIsModalOpen(false)}>
            <Header icon='send' content='Sent!' />
            <Modal.Content>
        <p>
                The task was updated, do you want to go back to the Task List:
        </p>
            </Modal.Content>
            <Modal.Actions>
              <Button basic color='red' inverted onClick={() => setIsModalOpen(false)}>
                <Icon name='remove' /> No
        </Button>
              <Button color='green' inverted as={Link} to={'.'}>
                <Icon name='checkmark' /> {status}
        </Button>
            </Modal.Actions>
          </Modal>
          <br />
          <br />
          <Grid padded textAlign="center">
            <Grid.Row>
              <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setTask(e.target.value) }}
                    id='form-subcomponent-shorthand-input-last-name'
                    label='Name of Task:'
                    defaultValue= {taskk}
                  />
                </Form.Group>
              </Form>
            </Grid.Row>
            <Grid.Row>
              <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setTime( e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    label='Time:'
                    defaultValue= {time}
                
                  />
                </Form.Group>
              </Form>
            </Grid.Row>
            <Grid.Row>
              <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setTaskdescription( e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    label='Description:'
                    defaultValue={taskDescription}
                  />
                </Form.Group>
              </Form>
            </Grid.Row>
            <Grid.Row>
            <Dropdown pointing="bottom"
                options={Frequency_Array}
                selection
                scrolling
                value={frequency}
                onChange={(e, { value }) => setFrequency(value)}
                upward={false}

   >
              </Dropdown>
            </Grid.Row>
            <Grid.Row>
              <Dropdown pointing="bottom"
                options={Importance_Array}
                selection
                scrolling
                upward={true}
                value={importance}
                onChange={(e, { value }) => setImportance(value)}
   >
              </Dropdown>
              
            </Grid.Row>
            <Grid.Row>
     
              <Dropdown pointing="bottom"
                options={items}
                selection
                scrolling
                upward={true}
                // value={caregiverFirst}
                onOpen={() => updateCaregiverID()}
                onChange={(e, { value }) => setCaregiverID(value)}>
              </Dropdown>
           
            </Grid.Row>
            <Grid.Row>
              <Button.Group>
                <Button icon labelPosition='left' as={Link} to={"/familymembers"} >Cancel<Icon name='cancel' /></Button>
                <Button.Or />
                <Button color='green' icon labelPosition='right' 
                onClick={(event) => updateTask(event)}
                as={Link}
                to={"/familymembers"}
                >
                  Save
            <Icon name='save' />
                </Button>
              </Button.Group>
            </Grid.Row>
          </Grid>
        </Container>
 
    );
}
export default EditTask;
  // function updateCaregiverID() {
    //   if (opened) {
    //     if (familyMembers && caregivers) {
    //       familyMembers[userid]["caregivers"].map((input) => {
    //         setItems(items => [...items, {
    //           key: caregivers[input]["id"],
    //           text: caregivers[input]["firstName"] + " " + caregivers[input]["lastName"],
    //           value: caregivers[input]["id"]
    //         }])
    //       })
    //       console.log(familyMembers[userid]["caregivers"])
    //     }
    //     setOpened(false);
  
    //   }
    //   console.log(items)
    // }
    // function sendMessage(event, input) {
    //   if (counter < 2) {
    //     event.preventDefault();
    //     counter = counter + 1;
    //   }
    //   else {
    //     event.returnValue = true;
    //   }
    //   setSubmitting(true);
    //   fetch('/api/messages', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(input)
    //   })
    //     .then(res => res.json())
    //     .then(data => {
    //       if (data.success) {
    //         console.log("suceeded");
    //         console.log(data.body);
    //         console.log(JSON.stringify(input))
    //         setError(false);
    //         setSubmitting(false);
    //       } else {
    //         console.log("failed");
    //         console.log(data.body);
    //         console.log(JSON.stringify(input))
    //         setError(true);
    //         setSubmitting(false);
    //       }
    //     });
    // }
    // const sendText = firebase.functions().httpsCallable('sendText');
  
  
    // function addNewTask(event, caregiverID) {
    //   console.log(frequency, importance)
    //   setIsModalOpen(true);
    //   setSubmitting(true);
    //   if (caregiverID != null) {
    //     const k = dbTasks.push({
    //       "description": taskDescription.value || null,
    //       "duration": duration.value || null,
    //       "familyMemberID": userid || null,
    //       "frequency": frequency || null,
    //       "importance": importance || null,
    //       "status": false,
    //       "taskName": task.value || null,
    //       "time": time.value || null,
    //       "caregiverId": caregiverID || "None"
    //     });
    //     console.log(k.path['pieces_'][1])
    //     let push = k.path['pieces_'][1];
    //     console.log(caregiverID);
    //     // var temp = dbFamMember.child(userid).child("tasks").().length-1;
    //     dbFamMember.child(userid).child("tasks").update({
    //       [push]: push || null
    //     });
  
    //     let c = "\nTask: " + task.value + "\nTime: " + time.value + "\nApproximate Duration: " + duration.value + "\nDescription: " + taskDescription.value + "\nImportance: " +
    //       importance.value + "\nFrequency: " + frequency.value;
    //     // setMessageBody(c); 
    //     var caregivername = " wrong";
    //     dbCaregivers.child(caregiverID).child("firstName").on("value", function (snapshot) {
    //       caregivername = snapshot.val()
    //     }, function (errorObject) {
    //       console.log("The read failed: " + errorObject.code);
    //     });
    //     var familyMemberName = "";
    //     dbFamMember.child(userid).child("firstName").on("value", function (snapshot) {
    //       familyMemberName = snapshot.val()
    //     }, function (errorObject) {
    //       console.log("The read failed: " + errorObject.code);
    //     });
  
    //     let messageee = "Congrats! You have added a task. " + caregivername + " will be notified!"
    //     var number = 0;
    //     var number2 = 0;
    //     dbFamMember.child(userid).child("phone").on("value", function (snapshot) {
    //       number = snapshot.val()
  
    //     }, function (errorObject) {
    //       console.log("The read failed: " + errorObject.code);
    //     });
    //     dbCaregivers.child(caregiverID).child("phone").on("value", function (snapshot) {
    //       number2 = snapshot.val()
  
    //     }, function (errorObject) {
    //       console.log("The read failed: " + errorObject.code);
    //     });
  
    //     let temp = { to: number, body: messageee };
    //     let temp2 = { to: number2, body: "Attention! " + familyMemberName + " has set a new task for you! Details as follow: " + c };
    //     console.log("this is temp1")
    //     console.log(temp)
    //     console.log("this is temp2")
    //     console.log(temp2)
  
  
    //     // sendText({data:temp})
    //     // sendText({data:temp2});
    //     event.returnValue = true;
  
    //   }
    // }
    // const contextRef = createRef();

    //below is  example form instead of  dropdown 
    {/* <Form size="large">
                <Form.Group widths='equal'>
                  <Form.Input
                    onChange={(e) => { setImportance({ value: e.target.value }) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    label='Importance'
                    placeholder='Importance'
                  />
                </Form.Group>
              </Form> */}